module.exports = "<h4 class=bc-toolbar-title ng-transclude></h4> ";